import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PayService } from 'src/app/models/pay-service';
import { ServiceType } from 'src/app/models/service-type';
import { ServiceService } from 'src/app/services/service.service';
import { getUtilitarianColumns } from 'src/app/src/utl';

@Component({
  selector: 'app-utilitarian-table',
  templateUrl: './utilitarian-table.component.html',
  styleUrls: ['./utilitarian-table.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UtilitarianTableComponent implements OnInit {

  @Input() pay_services:PayService[] = [];
  @Input() service_type:ServiceType = new ServiceType();
  @Input() type:string = 'utilitarian';
  @Output() emitUpdate:EventEmitter<PayService> = new EventEmitter();
  pay_services_unique:PayService[] = [];
  pay_services_temp:PayService[] = [];
  pay_service:PayService = new PayService();
  loading:boolean = false;
  expand:boolean = false;

  utilirian_columns:any[] = [];
  service_type_column:any[] = [];
  service_type_header:any[] = [];

  service_type_header_edit:any[] = [];

  constructor(private serviceServ:ServiceService, private modalService: NgbModal, private cdRef:ChangeDetectorRef) { }

  ngOnInit() {
    this.utilirian_columns = getUtilitarianColumns();
  }
  
  ngOnChanges(changes: SimpleChanges): void {
    this.pay_services = (changes.pay_services)?changes.pay_services.currentValue:this.pay_services;
    this.service_type = (changes.service_type)?changes.service_type.currentValue:this.service_type;
    this.type = (changes.type)?changes.type.currentValue:this.type;
    this.filterColumns();
  }

  ngAfterViewChecked()
{
  this.cdRef.detectChanges();
}

  filterColumns(){
    this.service_type_column = [];
    this.service_type_header = [];
    this.utilirian_columns.forEach(uti => {
      if(uti.type == this.type){
        this.service_type_header.push(uti);
        uti.columns.forEach(colum=>{
          this.service_type_column.push(colum);
        });
      }
    });
    this.pay_services_temp = this.pay_services.filter(pay=> this.service_type_header.findIndex(ser=>ser.id == pay.service_type_id && ser.type == this.type) != -1);
    this.getUnities();
  }

  getUnities() {
    this.pay_services_unique = [];
    this.pay_services_temp.forEach(pay=>{
      if(this.pay_services_unique.findIndex(payy=> payy.unity_id == pay.unity_id) == -1){
        this.pay_services_unique.push(pay);
      }
    });
  }

  getPayServices(pay_service){
    let pay_services = [];
    this.pay_services_temp.forEach(pay=>{
      if(pay_service.unity_id == pay.unity_id){
        pay_services.push(pay);
      }
    });
    return pay_services;
  }

  openModal(pay_service:PayService, servi, modal){
    this.pay_service = pay_service;
    this.service_type_header_edit = servi;
    this.modalService.open(modal, { size: 'lg', centered: true });
  }

  update(){
    this.loading = true;
    this.serviceServ.updatePayService(this.pay_service).subscribe(pay_service => {
      this.modalService.dismissAll();
      this.emitUpdate.emit(pay_service);
      this.loading = false;
    });
  }
}
